import { Tag } from '@/types/template';

import { backendRequest } from './http-client';

/**
 * Lists tags from the backend API for the current tenant.
 *
 * Pass `siteIds` to scope the result to one or more sites (A12 / D43) —
 * the wizard's shift-tag multi-select narrows to tags that exist at the
 * active template sites. Omit `siteIds` to list every tag on the realm.
 * Forwarded as a comma-separated `?siteIds=` query param; backend's
 * `parseSiteIdsQuery` accepts that shape.
 *
 * @throws Error if the API call fails
 */
export async function listTags(siteIds?: string[]): Promise<Tag[]> {
  const query = siteIds && siteIds.length > 0 ? `?siteIds=${siteIds.join(',')}` : '';
  return backendRequest<Tag[]>(`/v1/tags${query}`, 'Failed to list tags');
}
